import { create } from "zustand";
import { retrieveLanding, updateLanding } from "./actions";


type LandingStoreProps = {
    loading                : boolean    
    data                   : { [key:string]:any} | null
    retrieveLandingData    : () => void
    updateData             : (data:any) => Promise<void>
    error                  : string  
}

export const useLandingStore = create<LandingStoreProps>( (set,getState) => ({
    data: null,
    loading: false,
    error: "",
    retrieveLandingData() {
        set( state => ({loading: true, error: ""}))
        retrieveLanding()
            .then( data => set( state => ({data:data, loading:false})))
            .catch( err => set(state => ({loading:false, error:err})))
    },
    async updateData(data) {
        try {
            await updateLanding(data)
            set( state => ({data:data}))
        } catch (error) {
            set( state => ({error:"Failed updating data"}))
        }
    },
}))

